import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const SK: DeepPartial<AddressBook> = {};
